export default "__VITE_ASSET__B$Dzzt58__"